export const SET_LOADING_ENTREGADOR = "SET_LOADING_ENTREGADOR";
export const SET_ENTREGADOR = "SET_ENTREGADOR";
export const SET_PAGE_ENTREGADOR = "SET_PAGE_ENTREGADOR";
export const SET_PERPAGE_ENTREGADOR = "SET_PERPAGE_ENTREGADOR";
export const SET_ENTREGADORES = "SET_ENTREGADORES";
export const SET_ENTREGADORES_TOTAL = "SET_ENTREGADORES_TOTAL";
export const SET_FILTRO_ENTREGADORES = "SET_FILTRO_ENTREGADORES";
